import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  Dimensions,
  ScrollView,
  TouchableOpacity,
} from 'react-native';
import moment from 'moment';
import { Modal } from '@material-ui/core';

const StatusCard = ({ title, status, description, date }) => {
  // Determine status bubble style based on status
  const getStatusStyle = (status) => {
    if (status?.toUpperCase() === 'COMPLETE') {
      return {
        backgroundColor: '#4CAF50',
        textColor: '#FFFFFF'
      };
    }
    return {
      backgroundColor: '#FFEDF4',
      textColor: '#E91E63'
    };
  };

  const statusStyle = getStatusStyle(status);

  return (
    <View style={styles.card}>
      <View style={styles.cardHeader}>
        <Text style={styles.cardTitle}>{title}</Text>
        <View style={[styles.statusBubble, { backgroundColor: statusStyle.backgroundColor }]}>
          <Text style={[styles.statusText, { color: statusStyle.textColor }]}>{status}</Text>
        </View>
      </View>
      <Text style={styles.cardBody}>{description}</Text>
      <Text style={styles.cardDate}>
        Last Updated: <Text style={styles.boldText}>{date}</Text>
      </Text>
    </View>
  );
};

export default function ReferenceComponent({ showModal, onclose, data }) {
  return (
    <Modal
      open={showModal ? showModal : false}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
        margin: 30,
        borderRadius: 10
      }}
    >
      <ScrollView contentContainerStyle={styles.container}>
        <Text style={styles.heading}>{data?.name ? data.name : ""}</Text>

        <View style={styles.cardGrid}>
          <StatusCard
            title="Employment"
            status={data?.latestUpdate?.currentEmployment?.status ? data?.latestUpdate?.currentEmployment?.status : "-"}
            description={data?.latestUpdate?.currentEmployment?.comments ? data?.latestUpdate?.currentEmployment?.comments : "-"}
            date={data?.latestUpdate?.currentEmployment?.last_updated ? moment(data?.latestUpdate?.currentEmployment?.last_updated).format('DD/MM/YYYY') : "-"}
          />
          <StatusCard
            title="Credit Search"
            status={data?.latestUpdate?.creditSearch?.status ? data?.latestUpdate?.creditSearch?.status : "-"}
            description={data?.latestUpdate?.creditSearch?.comments ? data?.latestUpdate?.creditSearch?.comments : "-"}
            date={data?.latestUpdate?.creditSearch?.last_updated ? moment(data?.latestUpdate?.creditSearch?.last_updated).format('DD/MM/YYYY') : "-"}
          />
          <StatusCard
            title="Living Status"
            status={data?.latestUpdate?.currentLiving?.status ? data?.latestUpdate?.currentLiving?.status : "-"}
            description={data?.latestUpdate?.currentLiving?.comments ? data?.latestUpdate?.currentLiving?.comments : "-"}
            date={data?.latestUpdate?.currentLiving?.last_updated ? moment(data?.latestUpdate?.currentLiving?.last_updated).format('DD/MM/YYYY') : "-"}
          />
          <StatusCard
            title="Tenant Search"
            status={data?.latestUpdate?.tenantSearch?.status ? data?.latestUpdate?.tenantSearch?.status : "-"}
            description={data?.latestUpdate?.tenantSearch?.comments ? data?.latestUpdate?.tenantSearch?.comments : "-"}
            date={data?.latestUpdate?.tenantSearch?.last_updated ? moment(data?.latestUpdate?.tenantSearch?.last_updated).format('DD/MM/YYYY') : "-"}
          />
        </View>

        <TouchableOpacity
          onPress={() => onclose()}
          style={styles.okButton}>
          <Text style={styles.okText}>OK</Text>
        </TouchableOpacity>
      </ScrollView>
    </Modal>
  );
}

const screenWidth = Dimensions.get('window').width;

const styles = StyleSheet.create({
  container: {
    padding: 16,
    paddingBottom: 40,
    backgroundColor: '#F8F8FF',
    borderRadius: 20
  },
  heading: {
    fontSize: 20,
    fontWeight: '600',
    marginBottom: 16,
    color: '#333',
    textAlign: 'flex-start',
  },
  cardGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    width: screenWidth > 600 ? '47%' : '100%',
    elevation: 3,
    shadowColor: '#aaa',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: '500',
    color: '#9F6CCD',
  },
  statusBubble: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 20,
    minWidth: 80,
    alignItems: 'center',
  },
  statusText: {
    fontSize: 12,
    fontWeight: '500',
    textTransform: 'capitalize',
  },
  cardBody: {
    marginTop: 12,
    fontSize: 14,
    color: '#666',
  },
  cardDate: {
    marginTop: 8,
    fontSize: 13,
    color: '#555',
  },
  boldText: {
    fontWeight: '700',
  },
  okButton: {
    backgroundColor: '#9F6CCD',
    marginTop: 16,
    alignSelf: 'flex-end',
    paddingHorizontal: 32,
    paddingVertical: 12,
    borderRadius: 8,
  },
  okText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
});